<template>
  <v-container grid-list-xl>
    <v-layout row>
      <v-flex xs12 sm12 md12 lg10 offset-lg1 xl8 offset-xl2>
        <h1 class="display-2 text-xs-center mb-2 mt-2">
          Seller Resources
        </h1>
        <h2 class="subheading text-xs-center mb-3 font-italic logo-blue">
          We provide a few quick facts for Sellers that many find useful.
        </h2>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm12 md12 lg10 offset-lg1 xl8 offset-xl2>
        <v-card class="px-3">
          <v-card-title primary-title>
            <h3 class="headline mb-0 blue-grey--text text--darken-3">
              Las Vegas Area Short Sales
            </h3>
          </v-card-title>
          <v-card-text class="pt-0">
            <p>
              A <strong>short sale</strong> is a sale of real estate in which
              the proceeds from selling the property will fall short of the
              balance of debts secured by liens against the property, and the
              property owner cannot afford to repay the liens' full amounts, and
              whereby the lien holders agree to release their lien on the real
              estate and accept less than the amount owed on the debt. Any
              unpaid balance owed to the creditors is known as a deficiency.
              Short sale agreements do not necessarily release borrowers from
              their obligations to repay any deficiencies of the loans, unless
              specifically agreed to between the parties. However, Federal Debt
              Forgiveness Act legislation was passed to preclude deficiencies
              after a short sale is approved. The same is true of lenders on
              first loans and lenders on second loans — once the short sale is
              approved, no deficiencies are permitted after the short sale.
            </p>
            <p>
              A short sale is often used as an alternative to foreclosure
              because it mitigates additional fees and costs to both the
              creditor and borrower. Both often result in a negative credit
              report against the property owner.
            </p>
          </v-card-text>
        </v-card>
        <v-card class="mt-4 px-3">
          <v-card-title>
            <h3 class="headline mb-0 blue-grey--text text--darken-3">
              Why List With Us?
            </h3>
          </v-card-title>
          <v-card-text class="pt-0">
            <p>
              Since 2004, PR Properties Group has been serving Las Vegas,
              Henderson, and Boulder City clients with their real estate needs.
              Our agents know the area and have lived in Las Vegas and the
              surrounding areas. Use a realtor that you can trust and who puts
              your needs first. Whether we are representing you as the buyer or
              seller, you can rest assured that PR Properties Group has you
              covered.
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Sellers',
  metaInfo: {
    title: 'Seller Resources',
  },
};
</script>
